<template>
  <div id="app">
    <v-header/>
    <mode-nav :mode="mode"/>
    <router-view v-if="isValidContext"/>
    <landing v-else/>
  </div>
</template>

<script>
  import ModeNav from '@/components/home/ModeNav'
  import VHeader from '@/components/home/VHeader'
  import Landing from '@/views/Landing'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'home',
    components: { ModeNav, VHeader, Landing },
    computed: {
      ...mapGetters('context', ['site', 'sector', 'mode', 'period', 'customer', 'isValidContext'])
    },

    created() {
      this.INIT_CONTEXT()
      if (this.$route.name !== this.mode) this.$router.push({ name: this.mode })
    },

    methods: {
      ...mapMutations('context', ['INIT_CONTEXT'])
    }
  }
</script>

<style lang="scss" scoped>
  #app {
    height: 100vh;
    width: 100vw;
    background-color: $app-background;

    .v-header {
      height: 18%;
      width: 100%;
    }

    .mode-nav {
      position: relative;
      width: 100%;
      padding-left: 4rem;
      border-bottom: 1px solid #E8EAED;
      height: 40px;
      margin: 0;
    }
  }
</style>

